<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
@import url("./assets/fonts/flaticon.css");
#app {
  font-family: 'Alibaba PuHuiTi', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media (max-width: 767px) {
  html,
  body,
  #app {
    overflow-x: hidden;
    max-width: 100%;
  }
}
</style>








